import { Container, Box , Text, Heading } from '@chakra-ui/react'
import React from 'react'

function Brand() {
  return (
  <Box>
    
 
  <Box className='makeupBox' overflow="hidden" border="1px solid black" width="70%" ml="30px" gap="40px"  minChildWidth="200px" spacing="20px">
        <Box textAlign="start" >
            <Heading>A</Heading>
            <Text>ANASTASIA BEVERLY HILLS</Text>
            <Text>ABHATI SUISSE</Text>
            <Text>AZZARO</Text>
            <Text>ALPHA-H</Text>
            <Text>AVEDA</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>B</Heading>
            <Text>BURTS BEES</Text>
            <Text>BOBBI BROWN</Text>
            <Text>BEAUTY BLENDER</Text>
            <Text>BENEFIT COSMETICS</Text>
            <Text>BVLGARI</Text>
            <Text>BOACIA</Text>
            <Text>BURBERRY</Text>
            <Text>BRIOGEO</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>C</Heading>
            <Text>COACH</Text>
            <Text>CAOLION</Text>
            <Text>CLINIQUE</Text>
            <Text>CLARINS</Text>
            <Text>CHOPARD</Text>
            <Text>COSTUME NATIONAL</Text>
            <Text>CAROLINA HERRERA</Text>
            <Text>COVER FX</Text>
            <Text>CHLOE</Text>
            <Text>CAUDALIE</Text>
            <Text>CALVIN KLEIN FRAGRANCES</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>D</Heading>
            <Text>DAVIDOFF</Text>
            <Text>DOLCE & GABBANA</Text>
            <Text>DIESEL</Text>
            <Text>DUNHILL</Text>
            <Text>DIOR</Text>
            <Text>DEAR DAHLIA</Text>
            <Text>DYOSON</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>E</Heading>
            <Text>ELIE SAAB</Text>
            <Text>ESTEE LAUDER</Text>
            <Text>ELIZABETH ARDEN</Text>
            <Text>ERMENEGILDO ZEGNA</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>F</Heading>
            <Text>FOREO</Text>
            <Text>FOREST ESSENTIALS</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>G</Heading>
            <Text>GIORGIO ARMANI</Text>
            <Text>GLAM GLOW</Text>
            <Text>GUERLAIN</Text>
            <Text>GALLINEE</Text>
            <Text>GIVENCHY</Text>
            <Text>GUCCI</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>H</Heading>
            <Text>HUGO BOSS</Text>
            <Text>HUDA BEAUTY</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>I</Heading>
            <Text>ISSEY MIYAKE</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>J</Heading>
            <Text>JUICE BEAUTY</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>K</Heading>
            <Text>KAYALI</Text>
            <Text>KENZO</Text>
            <Text>KAMA AYURVEDA</Text>
            <Text>KORA ORGANICS</Text>
            <Text>KLARA COSMETICS</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>L</Heading>
            <Text>LANCOME</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>M</Heading>
            <Text>MAKE UP FOR EVER</Text>
            <Text>MARC JACOBS</Text>
            <Text>MOROCCANOIL</Text>
            <Text>MIU MIU</Text>
            <Text>MARIO BADESCU</Text>
            <Text>MOSCHINO</Text>
            <Text>M.A.C</Text>
            <Text>MICHAEL KORS</Text>
            <Text>MONTBLANC</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>N</Heading>
            <Text>NARCISO RODRIGUEZ</Text>
            <Text>NUDESTIX</Text>
            <Text>NATASHA DENONA</Text>
            <Text>NATIO</Text>
            <Text>NINA RICCI</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>O</Heading>
            <Text>OMORFEE</Text>
            <Text>OLIVE</Text>
            <Text>O.P.I</Text>
            <Text>OUAI</Text>
            <Text>OLAPLEX</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>P</Heading>
            <Text>PERCY & REED</Text>
            <Text>PIXI</Text>
            <Text>PACO RABANNE</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>R</Heading>
            <Text>ROBERTO CAVALLI</Text>
            <Text>RALPH LAUREN</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>S</Heading>
            <Text>SALVATORE FERRAGAMO</Text>
            <Text>SWATI COSMETICS</Text>
            <Text>SUNDAY RILEY</Text>
            <Text>SEPHORA COLLECIONS</Text>
            <Text>SMASHBOX</Text>
            <Text>STILA</Text>
            <Text>SIMPLY NAM</Text>
            <Text>SHISEIDO</Text>
            <Text>STARSKIN</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>T</Heading>
            <Text>PERCY & REED</Text>
            <Text>PIXI</Text>
            <Text>PACO RABANNE</Text>
        </Box>
        <Box textAlign="start"  >
            <Heading>V</Heading>
            <Text>VERSACE</Text>
            <Text>VOTRE</Text>
        </Box>
        <Box textAlign="start" >
            <Heading>W</Heading>
            <Text>WISHFUL</Text>
        </Box>
        <Box textAlign="start" >
            <Heading>Y</Heading>
            <Text>YVES SAINT LAURENT</Text>
        </Box>
    </Box>
    </Box>
  )
}

export default Brand